import { z } from "zod";
export const WorkUpdateOutcomeSchema = z.enum([
    "IN_PROGRESS",
    "INTERNAL_REVIEW",
    "CLIENT_REVIEW",
    "BLOCKED",
    "DONE_CLAIM"
]);
export const WorkUpdateRuleSetSchema = z.object({
    version: z.string().trim().min(1).max(100),
    minimumTitleCharacters: z.number().int().min(3).max(40).default(4),
    uncertaintyPhrases: z.array(z.string().trim().min(1).max(100)).max(100),
    signals: z.array(z.object({
        id: z.string().trim().regex(/^[a-z0-9][a-z0-9_-]{1,79}$/),
        outcome: WorkUpdateOutcomeSchema,
        phrases: z.array(z.string().trim().min(1).max(100)).min(1).max(100),
        checkpointMinutes: z.number().int().min(1).max(100_800)
    })).min(1).max(100)
}).superRefine((rules, context) => {
    const ids = new Set();
    for (const [index, rule] of rules.signals.entries()) {
        if (ids.has(rule.id)) {
            context.addIssue({ code: "custom", path: ["signals", index, "id"], message: "Signal rule IDs must be unique." });
        }
        ids.add(rule.id);
    }
});
//# sourceMappingURL=work-update-rules.js.map